import { usePostHog } from "@posthog/react";
import { useLayoutEffect } from "react";
import { useParams } from "react-router";
import useAuth from "./accessToken/hooks/useAuth";

export const useAccountId = () => useParams<{ accountId: string }>().accountId;

/**
 * @note Only for use in root App.tsx. There can only be one
 */
export const AccountIdChangedDispatcher = () => {
    const accountId = useAccountId();
    const posthog = usePostHog();
    const isInspecting = useAuth((state) => !!state.exchangeTokenPartnerId);

    useLayoutEffect(() => {
        // We use cookieless mode so we should not identify any user.
        // Instead, we identify the current account context using `accountId`,
        // or `${accountId}-inspect` in inspect mode, while still sending the
        // raw merchant account id as the `account_id` property.
        const posthogId = isInspecting ? `${accountId}-inspect` : accountId;
        posthog.identify(posthogId, {
            account_id: accountId,
            is_inspecting: isInspecting,
        });
    }, [accountId, posthog, isInspecting]);

    return null;
};
